/* *************************************营销活动创建*************************************** */
const crdmarket = resolve => require(["@/pages/marketing/crdmarket/index.vue"], resolve);

/***************************************营销活动报名*****************************************/
const shopreview = resolve => require(["@/pages/marketing/enroll/shopreview/index.vue"], resolve);
const shopinfo = resolve => require(["@/pages/marketing/enroll/shopinfo/index.vue"], resolve);
const review = resolve => require(["@/pages/marketing/enroll/review/index.vue"], resolve);
const enrollinfo = resolve => require(["@/pages/marketing/enroll/enrollinfo/index.vue"], resolve);
const actenroll = resolve => require(["@/pages/marketing/enroll/actenroll/index.vue"], resolve);
const enroll = resolve => require(["@/pages/marketing/enroll/index.vue"], resolve);

/***************************************营销活动管理******************************************/ 
/* 限时折扣 一口价 一分钱 路由 */
const marketManageIndex = resolve => require(['@/pages/marketing/marketmanage/index.vue'], resolve)
const marketing_datails = resolve => require(['@/pages/marketing/mixedManage/marketing_datails.vue'], resolve)
const marketing_registration = resolve => require(['@/pages/marketing/mixedManage/marketing_registration.vue'], resolve)
const marketing_created = resolve => require(['@/pages/marketing/mixedManage/marketing_created.vue'], resolve)
const marketing_set = resolve => require(['@/pages/marketing/mixedManage/marketing_set.vue'], resolve)
const marketing_create_finish = resolve => require(['@/pages/marketing/mixedManage/marketing_createdFinish.vue'], resolve)
const marketing_registrationDetails = resolve => require(['@/pages/marketing/mixedManage/marketing_registrationDetails.vue'], resolve)
/* 拼团活动路由 */
const group_create = resolve => require(['@/pages/marketing/group/group_created'],resolve)
const group_applyset = resolve => require(["@/pages/marketing/group/group_applyset.vue"],resolve)
const group_detail = resolve => require(["@/pages//marketing/group/group_detail.vue"],resolve)
const group_create_finish = resolve => require(["@/pages//marketing/group/group_create_finish"],resolve)
const group_registration =resolve => require(["@/pages//marketing/group/group_registration"],resolve)
const group_registration_detail = resolve => require(["@/pages//marketing/group/group_registration_detail"],resolve)
const group_record_detail = resolve => require(["@/pages//marketing/group/group_record_detail"],resolve)
/* 秒杀 */
const skillCreate = resolve => require(['@/pages/marketing/secondkill/create/index.vue'], resolve)
const skillSet = resolve => require(['@/pages/marketing/secondkill/create/marketing_set.vue'], resolve)
const skillFinish= resolve => require(['@/pages/marketing/secondkill/create/marketing_finish.vue'], resolve)
const skillSetFinish= resolve => require(['@/pages/marketing/secondkill/create/marketing_setFinish.vue'], resolve)
const skillDetail = resolve => require(['@/pages/marketing/secondkill/detail/index.vue'], resolve)
const skillExamineVerify = resolve => require(['@/pages/marketing/secondkill/examineVerify/index.vue'], resolve)
const skill_registration_details = resolve => require(['@/pages/marketing/secondkill/examineVerify/skill_registration_details.vue'], resolve)
/* 自购省分享赚管理 */
const shareProfit_create = resolve => require(['@/pages/marketing/shareProfit/shareProfit_create.vue'], resolve)
const shareProfit_set = resolve => require(['@/pages/marketing/shareProfit/shareProfit_set.vue'], resolve)
const shareProfit_detail = resolve => require(['@/pages/marketing/shareProfit/detail/shareProfit_detail.vue'], resolve)
const shareProfit_finish = resolve => require(['@/pages/marketing/shareProfit/shareProfit_finish.vue'], resolve)
const shareProfit_check = resolve => require(['@/pages/marketing/shareProfit/detail/index.vue'], resolve)
const shareProfit_check_details = resolve => require(['@/pages/marketing/shareProfit/detail/registration_details.vue'], resolve)
/*抽奖*/
const draw_create = resolve => require(['@/pages/marketing/draw/create/index.vue'], resolve)
const draw_set = resolve => require(['@/pages/marketing/draw/create/drawSet.vue'], resolve)
const draw_finish = resolve => require(['@/pages/marketing/draw/create/drawFinish.vue'], resolve)
const draw_drawDetail = resolve => require(['@/pages/marketing/draw/detail/index.vue'], resolve)
const draw_winning = resolve => require(['@/pages/marketing/draw/detail/winningRecord.vue'], resolve)
/* 会员礼品 */
const memberCreate = resolve=>require(['@/pages/marketing/memberGift/memberGift_create.vue'],resolve)
const memberGift_set = resolve=>require(['@/pages/marketing/memberGift/memberGift_set.vue'],resolve)
const memberGift_finish = resolve=>require(['@/pages/marketing/memberGift/memberGift_finish.vue'],resolve)
const memberGift_detail = resolve=>require(['@/pages/marketing/memberGift/memberGift_detail.vue'],resolve)
const memberGift_record = resolve=>require(['@/pages/marketing/memberGift/memberGift_record.vue'],resolve)
/*******************************************会员权益管理******************************************/
const memberRights = resolve => require(['@/pages/marketing/memberRights/index.vue'], resolve);
const memberRights_create = resolve => require(['@/pages/marketing/memberRights/memberRights_create.vue'], resolve)
const memberRights_detail = resolve => require(['@/pages/marketing/memberRights/memberRights_detail.vue'], resolve)
const memberRights_applySet = resolve => require(['@/pages/marketing/memberRights/memberRights_applySet.vue'], resolve)
const memberRights_createFinish = resolve => require(['@/pages/marketing/memberRights/memberRights_createFinish.vue'], resolve)
const memberRights_check = resolve => require(['@/pages/marketing/memberRights/memberRights_check.vue'], resolve);
const memberRights_check_detail = resolve => require(['@/pages/marketing/memberRights/memberRights_checkDetails.vue'], resolve)
/*秒杀自购分省*/
const skillAndShare_create = resolve => require(['@/pages/marketing/skillAndShare/create/index.vue'], resolve)
const skillAndShare_set = resolve => require(['@/pages/marketing/skillAndShare/create/skillAndShare_set.vue'], resolve)
const skillAndShare_finish = resolve => require(['@/pages/marketing/skillAndShare/create/skillAndShare_finish.vue'], resolve)
const skillAndShareDetail = resolve => require(['@/pages/marketing/skillAndShare/detail/index.vue'], resolve)
const skillAndShare_check = resolve => require(['@/pages/marketing/skillAndShare/examineVerify/index.vue'], resolve)
const skillAndShare_configGoods = resolve => require(['@/pages/marketing/skillAndShare/detail/configGoods.vue'], resolve)



export default [
    /* **********************************营销活动创建************************************ */
    {
        path: "/crdmarket",
        name: "营销活动创建",
        component: crdmarket
    },
    /* **********************************营销活动报名********************************* */
    {
        path: "/enroll",
        name: "营销活动报名",
        component: enroll
    },
    {
        path: "/enroll/actenroll",
        name: "发起活动报名",
        component: actenroll
    },
    {
        path: "/enroll/enrollinfo",
        name: "查看报名",
        component: enrollinfo
    },
    {
        path: "/enroll/review",
        name: "报名审核",
        component: review
    },
    {
        path: "/enroll/shopinfo",
        name: "商家报名商品信息",
        component: shopinfo
    },
    {
        path: "/enroll/shopreview",
        name: "审核商家",
        component: shopreview
    },
    /********************************营销活动管理**********************************/
    {
        path: "/marketmanage",
        component: marketManageIndex,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/marketmanage/marketMixManage/marketing_datails",
        component: marketing_datails

    },
    {
        path: "/marketmanage/marketMixManage/marketing_registration",
        component: marketing_registration

    },
    {
        path: "/marketmanage/marketMixManage/marketing_created",
        component: marketing_created
    },
    {
        path: "/marketmanage/marketMixManage/marketing_set",
        component: marketing_set
    },
    {
        path: "/marketmanage/marketMixManage/marketing_create_finish",
        component: marketing_create_finish
    },
    {
        path: "/marketmanage/marketMixManage/marketing_registration_details",
        component: marketing_registrationDetails
    },
    /* ****拼团**** */
    {
        path:'/marketmanage/group_create',
        component:group_create
    },
    {
        path:'/marketmanage/group_applyset',
        component:group_applyset,
    },
    {
        path:'/marketmanage/group_detail',
        component:group_detail
    },
    {
        path:'/marketmanage/create_finish',
        component:group_create_finish
    },
    {
        path:'/marketmanage/group_registration',
        component:group_registration
    },
    {
        path:'/marketmanage/group_registration_detail',
        component:group_registration_detail
    },
    {
        path:'/marketmanage/group_record_detail',
        component:group_record_detail
    },
    /* 秒杀路由 */
    {
        path:"/marketmanage/skillCreate",
        component:skillCreate
    },
    {
        path:"/skill/skillDetail",
        component:skillDetail
    },
    {
        path:"/marketmanage/skillSet",
        component:skillSet
    },{
        path:"/marketmanage/skillFinish",
        component:skillFinish
    },{
        path:"/marketmanage/skillSetFinish",
        component:skillSetFinish
    },{
        path:"/marketmanage/skillExamineVerify",
        component:skillExamineVerify
    },{
        path:"/marketmanage/skill_registration_details",
        component:skill_registration_details
    },
    /* 自购省 */
    {
        path: '/marketmanage/shareProfit_create',
        component: shareProfit_create
    },
    {
        path: '/marketmanage/shareProfit_set',
        component: shareProfit_set
    },
    {
        path: '/marketmanage/shareProfit_finish',
        component: shareProfit_finish
    },
    {
        path: '/marketmanage/shareProfit_detail',
        component: shareProfit_detail
    },
    {
        path: '/marketmanage/shareProfit_check',
        component: shareProfit_check
    },
    {
        path: '/marketmanage/shareProfit_check_details',
        component: shareProfit_check_details
    },
    /* 会员礼品 */
    {
        path:'/marketmanage/memberGiftCreate',
        component:memberCreate
    },
    {
        path:'/marketmanage/gift_set',
        component:memberGift_set
    },
    {
        path:'/marketmanage/memberGift_finish',
        component:memberGift_finish
    },
    {
        path:'/marketmanage/memberGift_detail',
        component:memberGift_detail,
    },
    {
        path:'/marketmanage/memberGift_record',
        component:memberGift_record
    },
    /************************************会员权益管理********************************** */
    {
        path: '/memberrights',
        component: memberRights,
        meta: {
            keepAlive: true,
        }
    },
    {
        path: '/memberrights/create',
        component: memberRights_create
    },
    {
        path: '/memberrights/detail',
        component: memberRights_detail,
    },
    {
        path: '/memberrights/create_finish',
        component: memberRights_createFinish,
    },
    {
        path: '/memberrights/apply_set',
        component: memberRights_applySet,
    },
    {
        path: '/memberrights/check',
        component: memberRights_check
    }, {
        path: '/memberrights/check_detail',
        component: memberRights_check_detail
    },
    /**************************抽奖******************************* */
    {
        path:"/marketmanage/drawCreate",
        component:draw_create
    },
    {
        path:"/marketmanage/drawSet",
        component:draw_set
    },
    {
        path:"/marketmanage/drawFinish",
        component:draw_finish
    },
    {
        path:"/marketmanage/drawFinish",
        component:draw_finish
    },
    {
        path:"/marketmanage/drawDetail",
        component:draw_drawDetail
    },
    {
        path:"/marketmanage/drawWinning",
        component:draw_winning
    },
    /**************************秒杀自购省******************************* */
    {
        path:"/marketmanage/skillAndShare_create",
        component:skillAndShare_create
    },
    {
        path:"/marketmanage/skillAndShare_set",
        component:skillAndShare_set
    },
    {
        path:"/marketmanage/skillAndShare_finish",
        component:skillAndShare_finish
    },
    {
        path:"/marketmanage/skillAndShare_detail",
        component:skillAndShareDetail
    },
    {
        path:"/marketmanage/skillAndShare_check",
        component:skillAndShare_check
    },
    {
        path:"/marketmanage/skillAndShare_configGoods",
        component:skillAndShare_configGoods
    },
];
